var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-6 mx-auto" },
      [
        _c("remote-newsroom-item", {
          attrs: { id: _vm.newsroomItemId },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var initialNewsroomItem = ref.newsroomItem
                return [
                  _c("newsroom-item-editor-wrapper", {
                    attrs: {
                      title: _vm.resource("Newsroom_Edit_Header"),
                      "newsroom-item": initialNewsroomItem
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "action-buttons",
                          fn: function(ref) {
                            var isValid = ref.isValid
                            var newsroomItem = ref.newsroomItem
                            return [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary navbar-btn",
                                  class: { disabled: !isValid },
                                  on: {
                                    click: function($event) {
                                      return _vm.submit(isValid, newsroomItem)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.resource("Newsroom_Edit_Submit_Btn")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.canDelete
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-danger navbar-btn delete-news",
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteItem()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.resource(
                                            "Newsroom_Delete_Submit_Btn"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }